// extracted by mini-css-extract-plugin
module.exports = {"base":"base--Bv4UJu","highlight":"highlight--LKqTwX","asterisk":"asterisk--G04MO2","error":"error--FvfN_g"};